import React from 'react';

const Spinner = ({ size = 30, color = "#3498db", loading = true }) => {
  if (!loading) return null;

  return (
    <div className="flex items-center justify-center">
      <div
        className="animate-spin rounded-full border-t-2 border-b-2"
        style={{
          width: size,
          height: size,
          borderColor: color,
          borderTopColor: 'transparent',
        }}
      />
    </div>
  );
};

export default Spinner;
